import { render, staticRenderFns } from "./basket-notification.vue?vue&type=template&id=0a8b1708&"
import script from "./basket-notification.vue?vue&type=script&lang=js&"
export * from "./basket-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports